module.exports = __webpack_public_path__ + "static/media/1POLICY41.24a2b188.jpg";